/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { object } from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';

import History from './History/History';
import PaymentMethod from './PaymentMethod/PaymentMethod';

/**
 * This is the Payments component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class Payments extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    user: object.isRequired,
  };

  /**
   * Render Payments.
   *
   * @return {Object}
   */
  render() {
    const { user } = this.props;

    return (
      <Switch>
        {user.is_client && (
          <Route exact path="/account/payments" component={History} />
        )}
        {user.is_talent && (
          <Route exact path="/account/payments" component={PaymentMethod} />
        )}
      </Switch>
    );
  }
}

export default connect(({ user }) => ({ user }))(Payments);
